import swaggerClient from "./../plugins/swagger-client";

export default class SettingsService {
  getSettings() {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.settings.getSettings(
          {},
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  updateSettings(payload) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.settings.updateSettings(
          {},
          swaggerClient.buildRequestBody(payload),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }
}
